import { render, staticRenderFns } from "./StorySixView.vue?vue&type=template&id=267c238b&"
import script from "./StorySixView.vue?vue&type=script&lang=js&"
export * from "./StorySixView.vue?vue&type=script&lang=js&"
import style0 from "./StorySixView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports